@if (aufgabe$ | async; as aufgabe) {
  <div class="page">
    <div class="content page-header">
      <h1 data-qa="page-title">Erstellter Vorgang</h1>
      <div class="page-actions">
        <a matButton="filled"
           data-qa="zurueck-zur-uebersicht"
           routerLink="/"
        >
          <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
          Zurück zur Übersicht
        </a>

        @if (bccAddresses.length > 0 && westnetzAdmin) {
          <a mat-mini-fab
             aria-label="Mail an Ersteller verfassen"
             data-qa="mail-button"
             href="mailto:?subject={{emailSubject}}&body={{emailBody}}&bcc={{bccAddressesForMailto}}"
             target="_blank"
          >
            <mat-icon color="primary">mail_outline</mat-icon>
          </a>
          <button mat-mini-fab
                  aria-label="Mail Template Dialog öffnen"
                  data-qa="show-email-template-button"
                  (click)="showEmailTemplate()"
          >
            <mat-icon color="primary">content_copy</mat-icon>
          </button>
        }

        @if (canDelete(aufgabe)) {
          <button
            (click)="delete(aufgabe)"
            class="button-warn"
            data-qa="delete-vorgang-button"
            matButton="filled"
          >
            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            Vorgang löschen
          </button>
        }
      </div>
    </div>
    <div class="content page-content">
      <mat-card class="basisinformationen mat-elevation-z2">
        <div class="background-{{aufgabe.type}}">
          <mat-card-actions>
            <div class="type type-{{aufgabe.type}}">{{ aufgabe.type | aufgabeTypeReadable }}</div>
          </mat-card-actions>
          <mat-card-title><h2 data-qa="details-aufgabe-name">{{ aufgabe.name }}</h2></mat-card-title>
          <mat-card-actions>
            <div class="details">
              <mat-icon>alarm</mat-icon>
              <span>{{ aufgabe.type | aufgabeTypeFristPrefix }}:&nbsp;{{ aufgabe.frist | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="details">
              <mat-icon>playlist_add_check</mat-icon>
              <span>{{ anzahlZuweisungenBestaetigt }} / {{ anzahlZuweisungen }}</span>
            </div>
            @if (aufgabe.mitUenbTeilen && authenticationService.isUenb(uflaUser); ) {
              <div class="details"
                   data-qa="erstellt-von-ersteller">
                <mat-icon fontSet="material-icons-outlined">assignment_ind</mat-icon>
                <span>Erstellt von:&nbsp;<b>{{ aufgabe.ersteller.name }}</b></span>
              </div>
            }
            @if (aufgabe.mitUenbTeilen && authenticationService.isVnb(uflaUser); ) {
              <div class="details"
                   data-qa="geteilt-mit-amprion">
                <mat-icon>share</mat-icon>
                <span>Geteilt mit:&nbsp;<b>Amprion</b></span>
              </div>
            }
            @if (aufgabe.emailBenachrichtigungSenden) {
              <div class="details" data-qa="emailBenachrichtigungSenden">
                <mat-icon>mail_outline</mat-icon>
                <span>E-Mail Benachrichtigung</span>
              </div>
            }
            @if (aufgabe.erinnerungsMail) {
              <div class="details" data-qa="erinnerungsMailSenden">
                <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
                <span>Erinnerung</span>
              </div>
            }
            @if (aufgabe.emailBenachrichtigungNachVorgangabschluss) {
              <div class="details" data-qa="emailBenachrichtigungNachVorgangabschluss">
                <mat-icon>mail</mat-icon>
                <span>Benachrichtigung nach Abschluss</span>
              </div>
            }
          </mat-card-actions>
        </div>
        <mat-card-content>
          <div>
            <h3 class="label">Kurzbeschreibung</h3>
            <p class="description">{{ aufgabe.kurzbeschreibung }}</p>
          </div>
        </mat-card-content>
        @if (dokumente$ | async; as dokumente) {
          <div>
            @if (dokumente.length > 0) {
              <div>
                <mat-card-title><h2>Angehängte Dateien</h2></mat-card-title>
                <mat-card-content>
                  <table mat-table class="attachment-table" data-qa="angehaente-dateien-dokumente"
                         [dataSource]="dokumente"
                  >
                    <tr mat-header-row
                        *matHeaderRowDef="columnsForDocuments"
                    ></tr>
                    <tr mat-row
                        *matRowDef="let even = even; let dokument; columns: columnsForDocuments"
                        [ngClass]="{gray: even}"
                    >
                    </tr>
                    <ng-container matColumnDef="fileName">
                      <th mat-header-cell
                          *matHeaderCellDef
                      >Name des Dokuments
                      </th>
                      <td mat-cell
                          *matCellDef="let dokument;"
                      >
                        <span>{{ dokument.fileName }}</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="lastModified">
                      <th mat-header-cell
                          *matHeaderCellDef
                      >Hochgeladen am
                      </th>
                      <td mat-cell
                          *matCellDef="let dokument;"
                      >
                        <span>{{ aufgabe.erstellungsDatum }}</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="icon">
                      <th mat-header-cell
                          *matHeaderCellDef
                      >
                      </th>
                      <td class="align-right"
                          mat-cell
                          *matCellDef="let dokument;"
                      >
                        <div class="dl">
                          @if (!dokument.downloading) {
                            <button mat-mini-fab
                                    aria-label="Download Dokument"
                                    (click)="downloadDocument(aufgabe.id, dokument)"
                            >
                              <mat-icon>cloud_download</mat-icon>
                            </button>
                          }
                          @if (dokument.downloading) {
                            <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
                          }
                        </div>
                      </td>
                    </ng-container>
                  </table>
                </mat-card-content>
              </div>
            }
          </div>
        }
      </mat-card>
      <mat-card class="zuweisungstabelle mat-elevation-z2">
        <mat-card-title><h2>Status der Empfänger</h2></mat-card-title>
        <mat-card-content>
          <table mat-table [dataSource]="zuweisungenDataSource" matSort class="attachment-table">
            <ng-container matColumnDef="ersteller.name">
              <th mat-header-cell fxFlex="40" *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell fxFlex="40" fxLayoutAlign="left center"
                  *matCellDef="let zuweisung">{{ zuweisung.ersteller.name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="ersteller.type">
              <th mat-header-cell fxFlex="20" *matHeaderCellDef mat-sort-header>Typ</th>
              <td mat-cell fxFlex="20" fxLayoutAlign="left center"
                  *matCellDef="let zuweisung">{{ zuweisung.ersteller.typ | orgTypeReadable }}
              </td>
            </ng-container>
            <ng-container matColumnDef="ersteller.kundenBetreuer">
              <th mat-header-cell fxFlex="20" *matHeaderCellDef mat-sort-header>Kundenbetreuer</th>
              <td mat-cell fxFlex="20" fxLayoutAlign="left center"
                  *matCellDef="let zuweisung">{{ zuweisung.ersteller.kundenBetreuer }}
              </td>
            </ng-container>
            <ng-container matColumnDef="gelesen">
              <th mat-header-cell fxFlex="10" *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell fxFlex="10" fxLayoutAlign="left center" *matCellDef="let zuweisung">
                @if (zuweisung.gelesen) {
                  <span class="rounded erledigt">erledigt</span>
                }
                @if (!zuweisung.gelesen) {
                  <span class="rounded offen">offen</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="replyFileName">
              <th mat-header-cell fxFlex="10" *matHeaderCellDef>
                <div class="dl">
                  @if (!allFilesDocument.downloading) {
                    <button matButton="outlined"
                            aria-label="Download alle Antworten"
                            (click)="downloadAllReplies()"
                    >
                      <mat-icon>cloud_download</mat-icon>
                      Alle
                    </button>
                  }
                  @if (allFilesDocument.downloading) {
                    <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
                  }
                </div>
              </th>
              <td mat-cell fxFlex="10" fxLayoutAlign="right center" *matCellDef="let zuweisung">
                @if (zuweisung.replyFileName) {
                  <div class="dl">
                    @if (!zuweisung.downloading) {
                      <button mat-mini-fab
                              aria-label="Download Antwort"
                              (click)="downloadReply(zuweisung)"
                      >
                        <mat-icon>cloud_download</mat-icon>
                      </button>
                    }
                    @if (zuweisung.downloading) {
                      <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
                    }
                  </div>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let zuweisung; columns: columnsToDisplay;"></tr>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
}
